import { checkForMorecontentLinks } from '../product-page';
import { checkInStock, displayBundleDetails, getBundleSku, paSizeButtonStyling, updateProductPriceHtml, updateVariationDescription } from './product-page-utils';

export function variationFunctionality() {
  updateVariationPriceOnLoad();
  addChangeEventHandlerToVariationSelects();
  addClickEventToChoiceContainer();
  displayProductDimensions();
  addVariationModalFunctionality();
  addEventsForFabricVariationSelect();
  paSizeButtonStyling();
}

/**
 * Om man kommer in till en sida med förvald storlek måste variantväljaren visa rätt val.
 * Detta måste dock göras när saldot har laddats klart så denna triggas när saldot hämtats.
 */
export function triggerChangeIfSizeInQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const sizeSelect = document.getElementById('pa_size');

  if (sizeSelect && urlParams.has('attribute_pa_size'))
    $(sizeSelect).trigger('change'); // Om event är skapat med jQuery så går det inte trigga det med vanilla. Remember
}

function updateVariationPriceOnLoad() {
  if (productInformationObj.type !== 'variable')
    return;

  if (productInformationObj.variations.length === 0)
    return;

  const firstVariation = productInformationObj.variations[0];

  updateProductPriceHtml(firstVariation);
}

function displayProductDimensions() {
  if ($('#pa_size').length == 0 && $('.hidden-dimensions').length > 0) {
    $('#var_dimensions-0').show();
  }
}

export function addVariationModalFunctionality() {
  $('.attribute-select').on('click', function (e) {
    e.stopPropagation();

    if ($(e.target).is($('.attribute-select'))) {
      $('.attribute-select').css('display', 'none').removeClass('open-attribute');
      $('body').css('overflow', 'visible');
    }
  });

  $('.variations tr').each(function () {
    // Om knapptrycket kommer på size- eller colorselectorn (som ska se vanlig ut) så bryt

    if ($(this).find('[id^="pa_size"]').length || $(this).find('[id^="pa_color"]').length) {
      return;
    }

    $(this).on('click', function (e) {
      e.stopPropagation();
      const parent = $(this).closest('.details');

      let currentPanel = $('label', this).attr('for');

      if (productInformationObj.type === 'bundle')
        currentPanel = currentPanel.split('_')[0];

      $('.attribute-select.' + currentPanel, parent).css('display', 'flex').addClass('open-attribute');
      $('body').css('overflow', 'hidden');
    });
  });
}

function updateProductDimensions(variation) {
  if ($('.hidden-dimensions').length === 0)
    return;

  $('div[id^=var_dimensions-]').hide();

  if (document.querySelector('[data-variation-id="' + variation.variation_id + '"]')) {
    document.querySelector('[data-variation-id="' + variation.variation_id + '"]').style.display = 'block';
  }
}

function updateProductWeights(variation) {
  if ($('.hidden-weights').length === 0)
    return;

  $('div[id^=var_weight-]').hide();

  if (document.querySelector('[data-test-id="' + variation.variation_id + '"]')) {
    document.querySelector('[data-test-id="' + variation.variation_id + '"]').style.display = 'block';
  }
}

function updateVariationStock(compareVal, variation) {
  // TODO Detta kommer inte lira om produkten har flera varianter
  if (variation.no_stock_item) {
    $('.out-of-stock-custom-container').text(productPageTranslations.noStockItemString);
    return;
  }

  $('.choices-container .single-choice').each(function() {
    const compareText = $('.choice-name', this).text();
    if (compareText == compareVal) {
      if (checkInStock('.variations_form', variation.sku)) {
        $('.out-of-stock-custom-container').text(productPageTranslations.inStockString);
      } else {
        $('.out-of-stock-custom-container').text(productPageTranslations.outOfStockString);
      }
    }
  });
}

function variationHasMultipleAttrs() {
  for (const variation of productInformationObj.variations) {
    if (variation.has_multiple_attrs)
      return true;
  }

  return false;
}

function addChangeEventHandlerToVariationSelects() {
  $('.variations select').each(function () {
    $(this).on('change', function (_) {
      let matchingVariation = null;
      const compareVal = $(this).val();

      if (variationHasMultipleAttrs()) { // Produkten måste ha alla varianter valda för att uppdateras
        const selectedValuesArr = [];
        let allValuesChecked = true;
        $('.variations select').each(function () {
          if (!$(this).val())
            allValuesChecked = false;

          selectedValuesArr.push($(this).val());
        });

        if (!allValuesChecked) {
          updateVariationDescription(productInformationObj.description);
          return;
        }

        for (const variation of productInformationObj.variations) {
          if (JSON.stringify(selectedValuesArr) === JSON.stringify(Object.values(variation.attributes))) // TODO undersök om dessa kan komma i fel ordning så de inte matchar array
            matchingVariation = variation;
        }
      } else {
        for (const variation of productInformationObj.variations) {
          if (Object.values(variation.attributes)[0] === compareVal) {
            matchingVariation = variation;
          } else {
            updateVariationDescription(productInformationObj.description);
          }
        }
      }

      if (!matchingVariation) { // Här är vi om man aktivt valt bort alla varianter
        clearVariationProductInformationIfNoChoice();
        return;
      }

      // Om produkten har size-selector så uppdatera alltid måttvisningen
      if (productInformationObj.hasSizeAttr) {
        updateProductDimensions(matchingVariation); // variationer av denna typ hanteras speciellt då de uppdaterar dimensionsHtml på produkten
        updateProductWeights(matchingVariation);
      }

      updateProductMetaFromVariation(compareVal, matchingVariation);
    });
  });
}

function clearVariationProductInformationIfNoChoice() {
  if (document.querySelector('.out-of-stock-custom-container'))
    document.querySelector('.out-of-stock-custom-container').textContent = '';

  if ($('.hidden-weights').length > 0)
    $('div[id^=var_weight-]').hide();

  if ($('.hidden-dimensions').length > 0)
    $('div[id^=var_dimensions-]').hide();
}

function updateProductMetaFromVariation(compareVal, variation) {
  updateProductPriceHtml(variation);
  updateVariationSku(variation.sku);
  updateVariationStock(compareVal, variation);

  if (variation.variation_description)
    updateVariationDescription(variation.variation_description);
  else
    updateVariationDescription(productInformationObj.description);

  checkForMorecontentLinks();
}

function updateVariationSku(sku) {
  $('.product-meta .product-sku .sku').text(sku);
}

// POPOVER
function addClickEventToChoiceContainer() {
  $('.choices-container .single-choice').on('click', function () {
    if ($('.expand', this).length > 0) {
      $(this).toggleClass('expanded');
      return;
    }

    if ($(this).closest('.attribute-select').hasClass('fabric'))
      return;

    const value = $('.choice-name', this).text();
    const parent = $(this).closest('.product');
    $(parent).attr('class').replace('attribute-select ', '');

    // TODO Kolla detta
    if ($('.attribute-select').length > 0) {
      const variationType = $(this).closest('.attribute-select').attr('class').split(' ')[1];
      $("label[for='" + variationType + "']").text(value);
      $('#' + variationType).val(value);
      $('#' + variationType).change();
    } else {
      $('.cart .value select', parent).val(value);
      $('.cart .value select', parent).change();
      $('.cart .label label', parent).text(value);
    }

    $('.attribute-select').css('display', 'none');
    $('body').css('overflow', 'visible');
  });
}

// För popup FABRICS
export function addEventsForFabricVariationSelect() {
  $('body').on('click', function(_) {
    if ($('.attribute-select.fabric').hasClass('open-attribute')) {
      $('body').css('overflow', 'visible');
      $('.attribute-select.fabric').removeClass('open-attribute').css('display', 'none');
    }
  });

  $('.expand .choice-image-container').on('click', function(e) {
    e.stopPropagation();

    if ($('#custom-fabric').length > 0) { // Osäker på vad denna handlar om :()
      const dataText = $('img', this).attr('data-text');
      $('#custom-fabric').val(dataText);
    }

    const parentDiv = $(this).closest('.multiple-choice');
    const grandparentDiv = $(this).closest('.single-choice');
    const selectValue = $('> .choice-name', grandparentDiv).text();
    const choiceName = $('.choice-name', parentDiv).text();

    const idForCorrespondingSelect = $(this).closest('.choices-container').data('choiceFor'); // Behövs för att trigga event på rätt select

    if (!idForCorrespondingSelect)
      return;

    $('[id^=' + idForCorrespondingSelect + ']').val(selectValue);
    $('[id^=' + idForCorrespondingSelect + ']').trigger('change');

    $('label[for="' + idForCorrespondingSelect + '"]').html('<span class="fabric-cat">' + selectValue + '</span><span class="fabric-name">' + choiceName + '</span>');

    let parent = $(parentDiv).closest('.attribute-select');

    if (productInformationObj.type === 'bundle') {
      parent = $(this).closest('tr');
    } else {
      parent = $(parentDiv).closest('.product');
    }

    const sku = getBundleSku(grandparentDiv, parent);
    displayBundleDetails(sku, parent);

    $('.attribute-select').css('display', 'none').removeClass('open-attribute');
    $('body').css('overflow', 'visible');
  });
}
